import RestApiModel from "@/api/Model/RestApiModel";

class DashboardDetails extends RestApiModel {
  static getResourceEndpoint() {
    return '/DashboardDetails';
  }
}

export default DashboardDetails;
